// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3Fp7x","label":"SetPasswdForm_label__2EXEg"};